import { logos } from './+logos/logos.ts';
import { type Route } from './+types/index.ts';

export const meta: Route.MetaFunction = () => [{ title: 'Epic Notes' }];

// Tailwind Grid cell classes lookup
const columnClasses: Record<(typeof logos)[number]['column'], string> = {
  1: 'xl:col-start-1',
  2: 'xl:col-start-2',
  3: 'xl:col-start-3',
  4: 'xl:col-start-4',
  5: 'xl:col-start-5',
};
const rowClasses: Record<(typeof logos)[number]['row'], string> = {
  1: 'xl:row-start-1',
  2: 'xl:row-start-2',
  3: 'xl:row-start-3',
  4: 'xl:row-start-4',
  5: 'xl:row-start-5',
  6: 'xl:row-start-6',
};

export default function Index() {
  return (
    <main className="font-poppins grid h-full place-items-center">
      Nothing to see here... go away!
    </main>
  );
}
